import React, { useId } from "react";
import { CalendarClock } from "lucide-react";

const ScheduledJobsIcon = ({ className = "" }) => {
  const gradientId = `scheduled-jobs-${useId().replace(/:/g, "")}`;

  return (
    <CalendarClock className={className} stroke={`url(#${gradientId})`} aria-hidden="true">
      <defs>
        <linearGradient id={gradientId} x1="3" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
          <stop stopColor="var(--photon-product-primary)" />
          <stop offset="1" stopColor="var(--photon-product-secondary)" />
        </linearGradient>
      </defs>
    </CalendarClock>
  );
};

export default ScheduledJobsIcon;